module.exports = __webpack_public_path__ + "img/server1.0387e27.png";